/* eslint-disable sonarjs/cognitive-complexity */
import React, { useMemo, useState, useEffect, useRef } from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import { Col, Drawer, List, Row, Typography } from 'antd';
import { capitalize } from 'lodash';
import { Form, Select, Input } from 'formik-antd';
import { useDispatch, useSelector } from 'react-redux';
import { Box, FormInput, CustomInput, Button, Text } from 'atoms';
import { getStates, getCities } from 'utils/location';
import { validateMobileNumber } from './FormValidation';
import { addUser, getPincodeList } from 'store/pageSlice';
import { createEmployeeV2, updateEmployeeV2 } from 'store/employeeSliceV2';
import { Debug } from './Debug';
import { getClientList, getUserTypes } from 'store/clientSlice';
import { searchClientFiltersV2 } from 'store/clientSliceV2';
import { getProjectListV2 } from 'store/projectSliceV2';
import { getUIVersion } from 'utils/router-static-data';
import { mobileError, empUserTypesOptions } from 'utils/config';
import { ACL, EditModeBtn, FilterTitle } from 'components/common';
// import { useQuery } from 'hooks';
import { ResetBtn } from 'components/reset-password';
import { AcctionContainer, CancelButton, FilterButton } from 'utils/commonStyled';
import { getUserType } from 'hooks/useAuth';
// import { ButtonWrapper } from 'components/ButtonWrapper';

const EMPLOYEES_ROUTE = '/employees';
const ERROR_FETCHING_PROJECTS_V2 = 'Error fetching projects V2:';
// User types that require project selection in V2
const USER_TYPES_REQUIRING_PROJECTS = [
	'supervisor',
	'city_manager',
	'management',
	'control_tower',
	'mis_executive',
];

export default function EmployeeForm({
	isEditMode = false,
	formData = {},
	zoneData = [],
	locations = {},
}) {
	const [statesData, setStates] = useState([]);
	const [citiesData, setCities] = useState([]);
	console.log(statesData, zoneData, citiesData);
	const [project_loccodes, setProjectlocalId] = useState('');
	const [clientsData, setClientsdata] = useState([]);
	const [cityVal, setCityVal] = useState('');
	const [projectsData, setProjects] = useState([]);
	// const [query] = useQuery();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const { statesWithCites } = useSelector((state) => state.clientState);
	const [open, setOpen] = useState(false);
	const [openClient, SetOpenClient] = useState(false);
	const [openProject, SetOpenProjects] = useState(false);
	const [zoneValues, setZoneValues] = useState([]);
	const [stateValues, setStateValues] = useState([]);
	const [cityalues, setCityalues] = useState([]);
	const [editMode, setEditMode] = useState(false);
	const [isCreate, setIsCreate] = useState(false);
	const [userTypeOptions, setUserTypeOptions] = useState([]);
	const [userTypesLoading, setUserTypesLoading] = useState(false);
	const [currentUserType, setCurrentUserType] = useState(null);
	const uiVersion = getUIVersion();
	const useV2API = uiVersion === 'new';

	console.log(zoneValues, stateValues, cityalues);
	console.log(localStorage.getItem('employee'));

	useEffect(() => {
		console.log('jjj');

		// CRITICAL: Do not call V1 API when V2 is active
		if (useV2API) {
			// V2: Skip project fetching via V1 API
			// Projects will be handled differently in V2 if needed
			setIsCreate(location.pathname.split('/').pop() === 'add');
			return;
		}

		// V1: Fetch projects when zones are selected
		if (zoneValues) {
			dispatch(
				getClientList({
					search_type: 'project',
					filter_by: {
						zones: zoneValues,
					},
				})
			).then((res) => {
				console.log(res);
				setProjects(
					res?.data?.map((item) => ({
						label: capitalize(item?.project_location_code),
						value: item?.id,
						id: item?.id,
						item,
					}))
				);
				setProjectlocalId(
					res?.data?.map((item) => ({
						id: item?.id,
						project_loc_codes: item?.project_location_code,
					}))
				);
			});
		}
		setIsCreate(location.pathname.split('/').pop() === 'add');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [zoneValues, dispatch, location.pathname]);

	useEffect(() => {
		setUserTypesLoading(true);
		if (useV2API) {
			// V2: Use static list (V2 API doesn't support user_type search)
			// This prevents V1 API call when "New UI" is active
			const userTypes = empUserTypesOptions || [];
			setUserTypeOptions(userTypes);
			setUserTypesLoading(false);
		} else {
			// V1 API: Use getUserTypes
			dispatch(getUserTypes({ data: { search_type: 'user_type', filter_by: {} } }))
				.then((res) => {
					if (Array.isArray(res)) {
						setUserTypeOptions(
							res.map((item) => ({ value: item.value, label: item.label }))
						);
					} else if (res && Array.isArray(res.data)) {
						setUserTypeOptions(
							res.data.map((item) => ({ value: item.value, label: item.label }))
						);
					}
					setUserTypesLoading(false);
				})
				.catch(() => setUserTypesLoading(false));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch]);

	// Sync currentUserType with formData on mount (for edit mode)
	useEffect(() => {
		if (formData?.user_type && !currentUserType) {
			setCurrentUserType(formData.user_type);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formData?.user_type]);

	// Fetch projects for V2 when user_type requires project selection
	useEffect(() => {
		// Only for V2 API and user types that require projects
		if (
			!useV2API ||
			!currentUserType ||
			!USER_TYPES_REQUIRING_PROJECTS.includes(currentUserType)
		) {
			// Clear projects if not a valid user type or not V2
			if (
				useV2API &&
				currentUserType &&
				!USER_TYPES_REQUIRING_PROJECTS.includes(currentUserType)
			) {
				setProjects([]);
			}
			return;
		}

		// Fetch projects using V2 API
		const fetchProjectsV2 = async () => {
			try {
				const result = await dispatch(
					getProjectListV2({
						filter_by: {},
						pagination: { page: 1, per_page: 1000 }, // Fetch all projects
					})
				);

				if (result?.rows) {
					// Map projects using project_name as the key
					const mappedProjects = result.rows.map((item) => ({
						label:
							item?.project_name ||
							item?.project_code ||
							item?.project_location_code ||
							'',
						value: item?.id,
						id: item?.id,
						item,
					}));

					setProjects(mappedProjects);
				}
			} catch (error) {
				console.error(ERROR_FETCHING_PROJECTS_V2, error);
				setProjects([]);
			}
		};

		fetchProjectsV2();
	}, [currentUserType, useV2API, dispatch]);

	const FormSchema = useMemo(
		() =>
			Yup.object({
				first_name: Yup.string()
					.min(1)
					.max(32)
					.label('First Name')
					.required()
					.matches(/^[a-zA-Z]*$/, 'First Name should only contain alphabets'),
				last_name: Yup.string()
					.min(1)
					.max(32)
					.label('Last Name')
					.required()
					.matches(/^[a-zA-Z]*$/, 'Last Name should only contain alphabets'),
				username: Yup.string()
					.max(32)
					.required()
					.label('Username')
					.matches(
						/^[a-zA-Z0-9-_.]*$/,
						'Invalid username. Usernames must start with a letter. Allowed characters are a-z (Both upper and lower case), 0-9, - (dash), and _ (underscore)'
					),
				email: Yup.string().required().email('Must be a valid email').label('Email'),
				password: Yup.string()
					.label('Password')
					.min(6)
					.max(16)
					.when([], {
						is: () => !isEditMode,
						then: Yup.string().required(),
						otherwise: Yup.string().notRequired(),
					}),
				clients: Yup.array(),
				user_type: Yup.string().required().label('User Type'),
				mobile_number: Yup.string()
					.required()
					.label('Mobile Number')
					.min(10, mobileError)
					.max(10, mobileError)
					.test('Not a valid Mobile Number', (value) => validateMobileNumber(value)),
				alternate_number: Yup.string()
					.nullable()
					.label('Alternative Mobile Number')
					.min(10, mobileError)
					.max(10, mobileError)
					.test('Not a valid Alternative Mobile Number', (value) =>
						validateMobileNumber(value)
					),
				employee_code: Yup.string()
					.matches(/^[aA-zZ0-9\s-_]+$/, 'Please enter valid employee code')
					.label('Employee Code')
					.required()
					.min(5)
					.max(10)
					.trim(''),
				designation: Yup.string()
					.matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed for Designation')
					.label('Designation')
					.required()
					.min(5)
					.max(100)
					.trim(''),
				zones: Yup.array().label('Zones'),
				// .when('user_type', (user_type, schema) => {
				// 	if (user_type && user_type !== 'admin') return schema.required();
				// 	return schema;
				// }),
				states: Yup.array().label('States'),
				// .when('user_type', (user_type, schema) => {
				// 	if (user_type && user_type !== 'admin') return schema.required();
				// 	return schema;
				// }),
				cities: Yup.array().label('Cities'),
				// .when('user_type', (user_type, schema) => {
				// 	if (user_type && user_type !== 'admin') return schema.required();
				// 	return schema;
				// }),
				client_ids: Yup.array().label('Clients'),
				// .when('user_type', (user_type, schema) => {
				// 	if (user_type && user_type !== 'admin') return schema.required();
				// 	return schema;
				// }),
				project_ids: Yup.array()
					.label('Projects')
					.min(1)
					.when('user_type', (user_type, schema) => {
						if (
							user_type &&
							user_type !== 'admin' &&
							user_type !== 'business' &&
							user_type !== 'finance'
						)
							return schema.required();
						return schema;
					}),
			}),
		[isEditMode]
	);

	const initialValues = useMemo(
		() => ({
			first_name: formData?.first_name || undefined,
			last_name: formData?.last_name || undefined,
			username: formData?.username || undefined,
			email: formData?.email || undefined,
			password: undefined,
			user_type: formData?.user_type || undefined,
			mobile_number: formData?.mobile_number || undefined,
			alternate_number: formData?.alternate_number || undefined,
			employee_code: formData?.employee_code || undefined,
			designation: formData?.designation || undefined,
			...(isEditMode && { id: formData?.id }),
			/**
			 * Other than admin user fields
			 */
			zones: undefined,
			states: undefined,
			cities: undefined,
			clients: formData?.employee_info?.clients || undefined,
			project_ids: formData?.employee_info?.project_ids || undefined,
			project_location_codes: formData?.employee_info?.project_location_codes || undefined,
		}),
		[formData, isEditMode]
	);

	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		console.log(values);
		const { zones, states, cities, project_ids, business_unit_ids } = values;

		console.log(zones, states, cities);
		console.log(projectsData);
		const project_location_codes = projectsData
			?.filter((item) => project_ids?.includes(item?.item?.id))
			?.map((it) => it?.item?.project_location_code);

		console.log(project_location_codes);

		// Prepare employee_info based on user_type
		if (
			values?.user_type !== 'admin' &&
			values?.user_type !== 'business' &&
			values?.user_type !== 'finance'
		) {
			if (useV2API) {
				// V2: Send both project_ids and project_location_codes for compatibility
				// Also include cities and business_unit_ids if available
				values.employee_info = {
					project_ids,
					project_location_codes,
					...(cities && cities.length > 0 && { cities }),
					...(business_unit_ids &&
						Array.isArray(business_unit_ids) &&
						business_unit_ids.length > 0 && { business_unit_ids }),
				};
			} else {
				// V1: Original format
				values.employee_info = {
					project_ids,
					project_location_codes,
				};
			}
		}

		if (useV2API) {
			// V2 API
			const submitAction = isEditMode ? updateEmployeeV2 : createEmployeeV2;
			dispatch(submitAction({ data: values, setErrors }))
				.then(() => {
					navigate(EMPLOYEES_ROUTE);
					setSubmitting(false);
				})
				.catch(() => {
					setSubmitting(false);
				});
		} else {
			// V1 API
			const payload = {
				data: values,
			};

			if (isEditMode) {
				payload.update_type = 'employee';
			} else {
				payload.create_type = 'employee';
			}
			console.log(payload);

			dispatch(addUser({ data: payload, setErrors, isEditMode }))
				.then(() => {
					navigate(EMPLOYEES_ROUTE);
					setSubmitting(false);
				})
				.catch(() => {
					setSubmitting(false);
				});
		}
	};

	function getProjectDataByzone(e) {
		// CRITICAL: Do not call V1 API when V2 is active
		if (useV2API) {
			return; // Skip V1 API call
		}

		dispatch(
			getClientList({
				search_type: 'project',
				filter_by: {
					zones: e,
				},
			})
		).then((res) => {
			console.log(res);
			setProjects(
				res?.data?.map((item) => ({
					label: capitalize(item?.project_location_code),
					value: item?.id,
					id: item?.id,
					item,
				}))
			);
			setProjectlocalId(
				res?.data?.map((item) => ({
					id: item?.id,
					project_loc_codes: item?.project_location_code,
				}))
			);
		});
	}

	function getProjectDataByState(e) {
		// CRITICAL: Do not call V1 API when V2 is active
		if (useV2API) {
			return; // Skip V1 API call
		}

		dispatch(
			getClientList({
				search_type: 'project',
				filter_by: {
					zones: zoneValues,
					states: e,
				},
			})
		).then((res) => {
			console.log(res);
			setProjects(
				res?.data?.map((item) => ({
					label: capitalize(item?.project_location_code),
					value: item?.id,
					id: item?.id,
					item,
				}))
			);
			setProjectlocalId(
				res?.data?.map((item) => ({
					id: item?.id,
					project_loc_codes: item?.project_location_code,
				}))
			);
		});
	}

	function getProjectDataByCity(e) {
		// CRITICAL: Do not call V1 API when V2 is active
		if (useV2API) {
			return; // Skip V1 API call
		}

		dispatch(
			getClientList({
				search_type: 'project',
				filter_by: {
					zones: zoneValues,
					states: stateValues,
					cities: e,
				},
			})
		).then((res) => {
			console.log(res);
			setProjects(
				res?.data?.map((item) => ({
					label: capitalize(item?.project_location_code),
					value: item?.id,
					id: item?.id,
					item,
				}))
			);
			setProjectlocalId(
				res?.data?.map((item) => ({
					id: item?.id,
					project_loc_codes: item?.project_location_code,
				}))
			);
		});
	}

	function handlePicodeChange(e) {
		console.log('handlePicodeChange', e?.target?.value);

		const pin_code = e?.target?.value;

		// CRITICAL: Do not call V1 API when V2 is active
		if (useV2API) {
			return; // Skip V1 API call
		}

		if (pin_code?.length === 6) {
			dispatch(getPincodeList(pin_code))
				.then((res) => {
					console.log('pincode response', res);
				})
				.catch((er) => {
					console.log('pincode error', er);
				});
		} else {
			console.log('not a valid pincode');
		}
	}

	function handleZoneChange(e, setFieldValue) {
		if (setFieldValue) {
			setFieldValue('states', undefined);
			setFieldValue('cities', undefined);
			setFieldValue('client_ids', undefined);
			// setFieldValue('project_ids', undefined);
		}
		setZoneValues(e);
		const selectedStates = getStates(locations, e);
		setStates([...selectedStates]);
		console.log(zoneValues);
		getProjectDataByzone(e);
	}

	function handleStatesChange(e, setFieldValue) {
		if (setFieldValue) {
			setFieldValue('cities', undefined);
			setFieldValue('client_ids', undefined);
			// setFieldValue('project_ids', undefined);
		}
		const selectedCites = getCities(statesWithCites, e);
		setCities([...selectedCites]);
		setStateValues(e);
		getProjectDataByState(e);
	}

	// function Cl() {
	// 	dispatch(
	// 		getClientList({
	// 			search_type: 'client',
	// 		})
	// 	).then((res) => {
	// 		const data = res?.data?.map((item) => ({
	// 			value: item?.id,
	// 			label: item?.client_name,
	// 			item,
	// 		}));
	// 		setClientsdata(data);
	// 	});
	// }

	function handleCitiesChange(e, setFieldValue) {
		setCityVal(e);
		if (setFieldValue) {
			setFieldValue('client_ids', undefined);
		}

		// V2 API: Call V2 client search when cities are selected
		if (useV2API) {
			setCityalues(e);

			// Call V2 client search API
			if (e && e.length > 0) {
				dispatch(
					searchClientFiltersV2({
						filter_by: {
							cities: e, // V2 API accepts cities as array
						},
						limit: 1000, // Fetch all matching clients
					})
				)
					.then((res) => {
						if (res?.results) {
							const data = res.results.map((item) => ({
								value: item?.id,
								label: item?.label || item?.client_legal_name || item?.company_name,
								item,
							}));
							setClientsdata(data);
						}
					})
					.catch((error) => {
						console.error('Error fetching clients V2:', error);
						setClientsdata([]);
					});
			} else {
				setClientsdata([]);
			}

			return; // Skip V1 API calls
		}

		// V1 API: Original logic
		dispatch(
			getClientList({
				search_type: 'client',
				filter_by: {
					project_cities: e,
				},
			})
		).then((res) => {
			const data = res?.data?.map((item) => ({
				value: item?.id,
				label: item?.client_name,
				item,
			}));
			setClientsdata(data);
		});
		console.log(cityVal);
		setCityalues(e);
		getProjectDataByCity(e);
	}

	function handleClientsChange(eClientId, setFieldValue) {
		console.log('eClientId', eClientId);
		if (setFieldValue) {
			// setFieldValue('project_ids', undefined);
		}
		console.log(cityVal);
		console.log(eClientId);

		// V2 API: Call V2 project search when clients are selected
		if (useV2API) {
			// Build filter_by object with zones, states, cities, and client_id
			const filterBy = {};

			// Add zones if available (V2 API might accept array or single value)
			if (zoneValues && zoneValues.length > 0) {
				filterBy.zones = zoneValues;
			}

			// Add states if available
			if (stateValues && stateValues.length > 0) {
				filterBy.states = stateValues;
			}

			// Add cities if available
			if (cityVal && cityVal.length > 0) {
				filterBy.cities = cityVal;
			}

			// Add client_id (V2 uses singular, take first if array)
			if (eClientId && eClientId.length > 0) {
				filterBy.client_id = Array.isArray(eClientId) ? eClientId[0] : eClientId;
			}

			dispatch(
				getProjectListV2({
					filter_by: filterBy,
					pagination: { page: 1, per_page: 1000 }, // Fetch all matching projects
				})
			)
				.then((result) => {
					if (result?.rows) {
						// Map projects using project_name as the key
						const mappedProjects = result.rows.map((item) => ({
							label:
								item?.project_name ||
								item?.project_code ||
								item?.project_location_code ||
								'',
							value: item?.id,
							id: item?.id,
							item,
						}));

						setProjects(mappedProjects);

						// Also update project_loccodes for compatibility
						setProjectlocalId(
							result.rows.map((item) => ({
								id: item?.id,
								project_loc_codes:
									item?.project_code || item?.project_location_code,
							}))
						);
					}
				})
				.catch((error) => {
					console.error(ERROR_FETCHING_PROJECTS_V2, error);
					setProjects([]);
				});

			return; // Skip V1 API call
		}

		// V1 API: Original logic
		dispatch(
			getClientList({
				search_type: 'project',
				filter_by: {
					client_ids: eClientId,
					cities: cityVal,
				},
			})
		).then((res) => {
			console.log(res);
			setProjects(
				res?.data?.map((item) => ({
					label: capitalize(item?.project_location_code),
					value: item?.id,
					id: item?.id,
					item,
				}))
			);
			setProjectlocalId(
				res?.data?.map((item) => ({
					id: item?.id,
					project_loc_codes: item?.project_location_code,
				}))
			);
		});

		console.log('project_loccodes', project_loccodes);
	}

	function useOnceCall(cb, condition = true) {
		const isCalledRef = useRef(false);

		useEffect(() => {
			if (condition && !isCalledRef.current) {
				isCalledRef.current = true;
				cb();
			}
		}, [cb, condition]);
	}

	function CheckForAdmin() {
		if (getUserType() !== 'admin' && isEditMode) {
			return true;
		}
	}

	function handleEdit() {
		console.log('before edit mode ', editMode);
		setEditMode(!editMode);
		console.log('after mode ', editMode);
	}

	function handleApplyFilter(values) {
		// V2 API: Search projects with selected zones, states, cities
		if (useV2API) {
			// Build filter_by object with zones, states, cities
			const filterBy = {};

			// Add zones if available
			if (values?.zones && values.zones.length > 0) {
				filterBy.zones = values.zones;
			}

			// Add states if available
			if (values?.states && values.states.length > 0) {
				filterBy.states = values.states;
			}

			// Add cities if available
			if (values?.cities && values.cities.length > 0) {
				filterBy.cities = values.cities;
			}

			// Call V2 project search API
			dispatch(
				getProjectListV2({
					filter_by: filterBy,
					pagination: { page: 1, per_page: 1000 }, // Fetch all matching projects
				})
			)
				.then((result) => {
					if (result?.rows) {
						// Map projects using project_name as the key
						const mappedProjects = result.rows.map((item) => ({
							label:
								item?.project_name ||
								item?.project_code ||
								item?.project_location_code ||
								'',
							value: item?.id,
							id: item?.id,
							item,
						}));

						setProjects(mappedProjects);

						// Also update project_loccodes for compatibility
						setProjectlocalId(
							result.rows.map((item) => ({
								id: item?.id,
								project_loc_codes:
									item?.project_code || item?.project_location_code,
							}))
						);
					} else {
						setProjects([]);
						setProjectlocalId([]);
					}
				})
				.catch((error) => {
					console.error('Error fetching projects V2:', error);
					setProjects([]);
					setProjectlocalId([]);
				});

			// Close the drawer
			setOpen(false);
			return;
		}

		// V1 API: Original logic - just close drawer (projects already fetched via handleZoneChange, etc.)
		setOpen(false);
	}

	useOnceCall(() => {
		/**
		 * On Edit mode prefill dropdowns of zones, states, cites, client_ids
		 */
		// CRITICAL: Do not call V1 API when V2 is active
		if (useV2API) {
			return; // Skip V1 API call
		}

		dispatch(
			getClientList({
				search_type: 'project',
				filter_by: {},
			})
		).then((res) => {
			console.log(res);
			setProjects(
				res?.data?.map((item) => ({
					label: capitalize(item?.project_location_code),
					value: item?.id,
					id: item?.id,
					item,
				}))
			);
			setProjectlocalId(
				res?.data?.map((item) => ({
					id: item?.id,
					project_loc_codes: item?.project_location_code,
				}))
			);
		});
	});

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
		>
			{({ values, setFieldValue }) => (
				<>
					<Box>
						<ACL action="update" module="employee">
							{isEditMode && (
								<Row gutter={16} justify="space-between">
									<ResetBtn username={formData?.username} />
									<EditModeBtn handleEdit={handleEdit} />
								</Row>
							)}
						</ACL>

						<Form className={editMode === false && !isCreate ? 'disabled-div' : ''}>
							<Box padding="1.5rem 2rem" background="#fff">
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="user_type" label="User Type *">
											<Select
												name="user_type"
												filterOption={(input, option) =>
													option.label
														.toLowerCase()
														.indexOf(input.toLowerCase()) >= 0
												}
												disabled={CheckForAdmin() || userTypesLoading}
												placeholder={
													userTypesLoading ? 'Loading...' : 'Select'
												}
												options={userTypeOptions}
												onChange={(value) => {
													setCurrentUserType(value);
													setFieldValue('user_type', value);
												}}
											/>
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput name="employee_code" label="Employee Code *">
											<CustomInput name="employee_code" />
										</FormInput>
									</Col>
								</Row>
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="first_name" label="First Name *">
											<CustomInput name="first_name" />
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput name="last_name" label="Last Name *">
											<CustomInput name="last_name" />
										</FormInput>
									</Col>
								</Row>
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="username" label="Username *">
											<CustomInput
												name="username"
												disabled={isEditMode}
												autocomplete="new-password"
											/>
										</FormInput>
									</Col>
									<Col lg={12}>
										{!isEditMode && (
											<FormInput name="password" label="Password *">
												<Input.Password
													name="password"
													autocomplete="new-password"
												/>
											</FormInput>
										)}
									</Col>
								</Row>
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="email" label="Email Address *">
											<CustomInput name="email" role="presentation" />
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput name="designation" label="Designation *">
											<CustomInput name="designation" />
										</FormInput>
									</Col>
								</Row>
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="mobile_number" label="Mobile Number *">
											<CustomInput name="mobile_number" maxLength={10} />
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput
											name="alternate_number"
											label="Alternate Mobile Number"
										>
											<CustomInput name="alternate_number" maxLength={10} />
										</FormInput>
									</Col>
								</Row>
								{isEditMode &&
									values?.user_type &&
									values?.user_type !== 'admin' &&
									values?.user_type !== 'business' &&
									values?.user_type !== 'finance' && (
										<Row gutter={16} justify="space-between">
											<Col lg={12}>
												<Box>
													<FormInput label="Clients" name="clients">
														<Select
															disabled
															readOnly
															mode="multiple"
															name="clients"
															filterOption={(input, option) =>
																option.label
																	.toLowerCase()
																	.indexOf(input.toLowerCase()) >=
																0
															}
															options={clientsData}
															maxTagCount="responsive"
														/>
													</FormInput>
												</Box>
												<Box></Box>
											</Col>
											<Col lg={12}>
												<Box margin="32px 0px">
													<FilterButton
														onClick={() => {
															SetOpenClient(true);
														}}
														type="button"
													>
														Show Clients
													</FilterButton>
												</Box>
											</Col>
										</Row>
									)}
								{values?.user_type &&
									values?.user_type !== 'admin' &&
									values?.user_type !== 'business' &&
									values?.user_type !== 'finance' && (
										<Row gutter={16} justify="space-between">
											<Col lg={12}>
												<FormInput
													name="project_ids"
													label="Select Project Location Codes *"
												>
													<Select
														allowClear
														mode="multiple"
														name="project_ids"
														filterOption={(input, option) =>
															option.label
																.toLowerCase()
																.indexOf(input.toLowerCase()) >= 0
														}
														options={projectsData}
														placeholder="Select"
														maxTagCount="responsive"
													/>
												</FormInput>
											</Col>
											<Col lg={12}>
												<Box margin="32px 0px">
													<FilterButton
														onClick={() => {
															setOpen(true);
														}}
														type="button"
													>
														Seach By Filter
													</FilterButton>

													{isEditMode && (
														<FilterButton
															onClick={() => {
																SetOpenProjects(true);
															}}
															type="button"
														>
															Show Projects
														</FilterButton>
													)}
												</Box>
											</Col>
										</Row>
									)}
								<Row gutter={16} justify="space-between" className="hide">
									<Col lg={12}>
										<FormInput
											name="pincode"
											label="Pincode *"
											onChange={handlePicodeChange}
										>
											<CustomInput name="pincode" />
										</FormInput>
									</Col>
									<Col lg={12}></Col>
								</Row>
							</Box>

							<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
								<CancelButton
									onClick={() => navigate(EMPLOYEES_ROUTE)}
									type="button"
								>
									Cancel
								</CancelButton>
								<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
									{isEditMode ? 'Update' : 'Submit'}
								</Button>
							</Box>
							<Debug />
						</Form>
					</Box>
					<Drawer
						className="userList-drawer"
						title={<FilterTitle title="Filter" onClose={() => setOpen(false)} />}
						placement="right"
						closable={false}
						onClose={() => setOpen(false)}
						open={open}
					>
						<Box>
							<Box mb="2rem">
								<Text mb="5px">Zones</Text>
								<Select
									allowClear
									style={{ width: '100%' }}
									mode="multiple"
									name="zones"
									filterOption={(input, option) =>
										option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									options={zoneData}
									onChange={(e) => handleZoneChange(e, setFieldValue)}
									placeholder="Select"
									maxTagCount="responsive"
								/>
							</Box>
							<Box mb="2rem">
								<Text mb="5px">States</Text>

								<Select
									disabled={!values?.zones || values?.zones?.length === 0}
									allowClear
									mode="multiple"
									name="states"
									style={{ width: '100%' }}
									filterOption={(input, option) =>
										option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									options={statesData}
									onChange={(e) => handleStatesChange(e)}
									placeholder="Select"
									maxTagCount="responsive"
								/>
							</Box>
							<Box mb="2rem">
								<Text mb="5px">cities</Text>
								<Select
									disabled={!values?.states || values?.states?.length === 0}
									allowClear
									mode="multiple"
									name="cities"
									style={{ width: '100%' }}
									filterOption={(input, option) =>
										option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									options={citiesData}
									onChange={(e) => handleCitiesChange(e, setFieldValue)}
									placeholder="Select"
									maxTagCount="responsive"
								/>
							</Box>
							<Box mb="2rem">
								<Text mb="5px">Clients</Text>
								<Select
									disabled={!values?.cities || values?.cities?.length === 0}
									allowClear
									mode="multiple"
									name="client_ids"
									style={{ width: '100%' }}
									filterOption={(input, option) =>
										option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									options={clientsData}
									onChange={(e) => handleClientsChange(e, setFieldValue)}
									placeholder="Select"
									maxTagCount="responsive"
								/>
							</Box>
							<br />
							<br />

							<br />
						</Box>
						<AcctionContainer>
							<Box textAlign="right" padding="1.5rem">
								<CancelButton onClick={() => setOpen(false)} type="button">
									Cancel
								</CancelButton>
								<Button
									borderRadius="4px"
									backgroundColor="#18405d"
									type="button"
									onClick={() => handleApplyFilter(values)}
								>
									Apply
								</Button>
							</Box>
						</AcctionContainer>
					</Drawer>
					<Drawer
						className="userList-drawer"
						title={<FilterTitle title="Clients" onClose={() => SetOpenClient(false)} />}
						placement="right"
						closable={false}
						onClose={() => SetOpenClient(false)}
						open={openClient}
					>
						<Box>
							<List
								bordered
								dataSource={values?.clients}
								renderItem={(item) => (
									<List.Item>
										<Typography.Text mark></Typography.Text> {item}
									</List.Item>
								)}
							/>
						</Box>
					</Drawer>
					<Drawer
						className="userList-drawer"
						title={
							<FilterTitle title="Projects" onClose={() => SetOpenProjects(false)} />
						}
						placement="right"
						closable={false}
						onClose={() => SetOpenProjects(false)}
						open={openProject}
					>
						<Box>
							<List
								bordered
								dataSource={values?.project_location_codes}
								renderItem={(item) => (
									<List.Item>
										<Typography.Text mark></Typography.Text> {item}
									</List.Item>
								)}
							/>
						</Box>
					</Drawer>
				</>
			)}
		</Formik>
	);
}

EmployeeForm.propTypes = {
	isEditMode: PropTypes.bool,
	formData: PropTypes.object,
	zoneData: PropTypes.any,
	locations: PropTypes.object,
};
